import { render, staticRenderFns } from "./AmeldingFormSubUnit.vue?vue&type=template&id=642a7c64&scoped=true&"
import script from "./AmeldingFormSubUnit.vue?vue&type=script&lang=ts&"
export * from "./AmeldingFormSubUnit.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingFormSubUnit.vue?vue&type=style&index=0&id=642a7c64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642a7c64",
  null
  
)

export default component.exports